<template>
  <div class="header-doctors-mobile">
    <NuxtLink
      v-for="profession in professions"
      :key="profession.id"
      class="header-doctors-mobile__link"
      :to="{ path: '/doctors', query: { profession_id: profession.id } }"
    >
      {{ profession.title }}
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { useState } from '#imports';
import type { ProfessionsItem } from '~/types/config';

const professions = useState<ProfessionsItem[]>('professions', () => []);
</script>

<style scoped lang="scss">
.header-doctors-mobile {
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-left: 16px;

  &__link {
    color: $color-typography-invert;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-decoration: none;
  }
}
</style>
